// Format rupiah dipatok ke locale id-ID, bukan locale browser. Sebelumnya
// nilainya dilewatkan toLocaleString() tanpa argumen, sehingga pengunjung
// ber-locale en-US melihat "320,000" sementara yang id-ID melihat "320.000"
// untuk harga yang sama.
const RUPIAH = new Intl.NumberFormat('id-ID', { maximumFractionDigits: 0 });

const formatNumberWithout = (number) => {
  const value = Number(number);
  return Number.isFinite(value) ? RUPIAH.format(value) : '0';
};

export { formatNumberWithout };
